import React, { useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Lang } from "../../../lang";
import AdminClientEnvelopeUpgrade from "./partials/AdminClientEnvelopeUpgrade";
import AdminClientUseTemplate from "./AdminClientUseTemplate";

function AdminClientPortalHome() {
    let { client } = useParams();

    document.title = Lang.homepage_title;
    document.getElementsByTagName("META")[4].content = Lang.homepage_meta_desc;
    document.getElementsByTagName("META")[5].content = Lang.homepage_meta_keyword;

    const [isUseTemplate, setIsUseTemplate] = useState(false);
    const navigate = useNavigate();

    function onEnvelopeStart(e) {
        e.preventDefault();
        navigate("/back-admin/client-portal/" + client + "/sleeve");
    }

    const handleUseTemplate = (e) => {
        e.preventDefault();
        setIsUseTemplate(true);
    };

    return (
        <>

            <section className="main_wrapper section_bg_color landing_section py-5 mt-5" style={{ minHeight: "calc(100vh - 105px)" }}>
                <div className="container">
                    <h2 className="main_title text-dark">Create an Sleeves</h2>
                    <p className="main_text">{Lang.home_text}</p>
                    <div className="row scratch_template d-flex flex-wrap align-items-stretch">
                        {/* Card 1: Start From Scratch */}
                        <div className="col-md-12 col-lg-4 col-sm-12">
                            <div className="cur-pointer h-100" onClick={onEnvelopeStart} data-bs-toggle="offcanvas"
                                data-bs-target="#useTemplate">
                                {/* <NavLink to={'/back-admin/client-portal/' + client + '/sleeve'}> */}
                                    <div className="small_card card">
                                        <div className="card_content d-lg-inline-block d-xl-flex d-sm-flex d-sm-inline-block">
                                            <div className="card_writeside">
                                                <div className="template_count_circle">+</div>
                                            </div>
                                            <div className="start_now">
                                                <h3>Start From Scratch</h3>
                                                <p>A blank Sleeve for collecting list of Documents.</p>
                                                <button onClick={onEnvelopeStart} type="button" data-toggle="tooltip"
                                                    data-placement="right"
                                                    data-bs-original-title={Lang.home_start_scratch} title="">
                                                    Start Now
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                {/* </NavLink> */}
                            </div>
                        </div>

                        {/* Card 2: Use Template */}
                        <div className="col-md-12 col-sm-12 col-lg-4 my-xl-0 my-lg-0 my-md-3 my-3">
                            <div className="cur-pointer h-100" onClick={handleUseTemplate} data-bs-toggle="offcanvas"
                                data-bs-target="#useTemplate">
                                <div className="small_card card">
                                    <div className="card_content d-lg-inline-block d-xl-flex d-sm-flex d-sm-inline-block">
                                        <div className="card_writeside">
                                            <div className="template_count_circle">+</div>
                                        </div>
                                        <div className="start_now">
                                            <h3>Use Template</h3>
                                            <p>Premade Template for collecting list of Documents. </p>
                                            <div className=" start_now d-flex justify-content-end">
                                                <button onClick={handleUseTemplate} type="button" data-toggle="tooltip"
                                                    data-placement="right"
                                                    data-bs-original-title={Lang.home_use_template}
                                                    data-bs-toggle="offcanvas" data-bs-target="#useTemplate" title="">
                                                    Start Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Card 3: Small Card 1 */}
                        <div className="col-md-12 col-sm-12 col-lg-4">
                            <NavLink to={'/billing/pricing'} className='text-decoration-none'>
                                <div className="small_card card">
                                    {/* <div className="card_content"> */}
                                    <AdminClientEnvelopeUpgrade />
                                    {/* </div> */}
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

            <AdminClientUseTemplate isUseTemplate={isUseTemplate} setIsUseTemplate={setIsUseTemplate} />
        </>
    );
}

export default AdminClientPortalHome;